import React from 'react';
import AreaTitle from '../AreaTitle';
import ImplementationModel from '../ImplementationModel';

class Home extends React.Component {

  componentDidMount() {
    this.props.updateState({
      phase: 1
    });
  }

  render() {
    return (
      <div className="view-content">
        <AreaTitle text="Valitse toteutustapa"/>
        <div className="card-wrapper">
          <div className="card not-selectable">
          Valitse ensin investoinnin toteutustapa. Seuraavalla sivulla näet, mitkä rahoitusmallit soveltuvat valitsemaasi toteutustapaan.
          </div>
        </div>
        {this.props.state.implementationModels.map((model, key) =>
          <ImplementationModel key={model.slug} state={this.props.state} model={model} selectImplementationModel={this.props.updateState} selected={model.slug === this.props.state.implementationModel}/>
        )}
      </div>
    );
  }
}

export default Home;
